/** @jsx jsx */
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { jsx } from "@emotion/react";
import { useMediaQuery } from 'react-responsive';
import { Link } from "gatsby";
import {
  EscolaBiligue,
  content,
} from "../assets/styles/AboutTwo.styles";

import ImgEscolaDePresente from "../assets/images/LP-kingdom/ensino-bilingue.png";

const AboutTwo = () => {
  const [setCounter] = useState({
    startCounter: false,
  });
  const isMobile = useMediaQuery({
    query: '(max-width: 850px)'
  })

  return (
    <section css={EscolaBiligue}>
      {isMobile && 
      <Col
      className="img-container px-0"
      data-aos="fade-right"
      lg={6}
      md={12}
      sm={12}
    >
      <img src={ImgEscolaDePresente} alt=" " />
    </Col>}
      <Container fluid>
        <Row className="title-content">
        {!isMobile &&
          <Col
          className="img-container px-0"
          data-aos="fade-right"
          lg={6}
          md={12}
          sm={12}
        >
          <img src={ImgEscolaDePresente} alt=" " />
        </Col>}
          <Col css={content} lg={6} md={12} sm={12}>
            <div>
              <h1 style={{ maxWidth: 450 }}>Ensino bilíngue com integração curricular diária</h1>
              <p style={{ maxWidth: 450, marginBottom: 40 }}>No Ensino Fundamental II, o inglês está presente diariamente e compõe 50% da grade curricular. A língua é utilizada de forma consistente em disciplinas como Science, Assembly, Physical Education, Global Thinking e Language Arts, integrando conteúdos, projetos e práticas acadêmicas que desenvolvem leitura, escrita, escuta e expressão oral em contextos reais de aprendizagem.</p>
                <div className="btn-section">
                <Link to="/fale-conosco" style={{ color: '#FFFFFF' }}>Quero agendar uma visita</Link>
              </div>
            </div>
          </Col>        
        </Row>
      </Container>
    </section>
  );
};

export default AboutTwo;
